// The waitlist (docs/plans/waitlist.md): what joining sends, checked the same way by the page and the server.
import { z } from 'zod';

/** The privacy notice people join under (web/privacy.html). Change it whenever the notice changes. */
export const NOTICE_VERSION = '2026-11-01';

/** Where someone came from, from the page's link: inkglish.com/?ref=youtube. Anything else is dropped. */
export const sourceSchema = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z0-9_-]{1,40}$/);

export const waitlistJoinSchema = z.object({
  email: z.string().trim().toLowerCase().max(254).pipe(z.email()),
  source: sourceSchema.optional().catch(undefined),
  // A field people never see: only bots fill it in.
  website: z.string().max(200).optional().catch(undefined),
});

export type WaitlistJoin = z.input<typeof waitlistJoinSchema>;
